import styled from 'styled-components';
import { Table, theme } from 'components';

export const BorderedTable = styled(Table)`
  & .ant-table {
    border: 1px ${theme.neutral4} solid;
  }
`;

export const Spacer = styled.div<{ $height: number }>`
  ${({ $height }) => `height: ${$height}px;`}
  width: 100%;
`;

export const StyledTabBar = styled.div`
  background-color: ${theme.white};
  && {
    > div {
      margin-bottom: 10px;
    }
    .ant-tabs-tab {
      &,
      &:focus,
      &:active {
        > * {
          color: ${theme.getColor('textSecondary')};
        }
      }
      .ant-tabs-tab-btn:hover {
        color: ${theme.blue6};
      }
    }
    .ant-tabs-tab-active {
      &,
      &:focus,
      &:active {
        > * {
          color: ${theme.blue6};
        }
      }
    }
  }
`;
